import { useTheme } from 'next-themes';
import { type ReactNode,useEffect, useState } from 'react';

export const ThemedIllustration = ({
  light,
  dark,
}: {
  light: ReactNode;
  dark: ReactNode;
}) => {
  const { resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return <>{light}</>;
  return <>{resolvedTheme === 'dark' ? dark : light}</>;
};
